import { render, staticRenderFns } from "./ChatBotQuestions.vue?vue&type=template&id=30462433&scoped=true&"
import script from "./ChatBotQuestions.vue?vue&type=script&lang=js&"
export * from "./ChatBotQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotQuestions.vue?vue&type=style&index=0&id=30462433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30462433",
  null
  
)

export default component.exports